<div class="mx-3">
  <div class="d-flex justify-content-between">
    <h2>{{ report.id ? report.name : ('REPORT.ADD'|translate) }}</h2>
    <div class="">
      <button class="btn btn-primary mb-1" (click)="goToList()">{{ 'FUNCTION-BUTTONS.CANCEL' | translate }}
      </button>
      @if (user?.roles.length>0 && (user?.roles.includes('EDITOR') || user?.roles.includes('ADMIN'))) {
        <button type="submit" class="btn btn-primary mb-1" (click)="submit()"
          >{{ 'FUNCTION-BUTTONS.SAVE' | translate }}
        </button>
      }
      <button type="button" class="btn btn-primary mb-1" [disabled]="!report.id || running"
        (click)="run()">
        @if (running) {
          <span class="spinner-border spinner-border-sm mr-1" role="status"></span>
        }
        {{ 'REPORT.RUN' | translate }}
      </button>
    </div>
  </div>

  <div class="col-xs-12 mt-5">

    <div [hidden]="submitted">
      <form (ngSubmit)="onSubmit()" #reportForm="ngForm">
        <div class="shadowBox">
          <div class="form-group" style="">

            <label for="name">{{ 'REPORT.NAME' | translate }}</label>
            <input type="text" class="form-control" id="name" [(ngModel)]="report.name" name="name"
              [maxLength]="30"
              #name="ngModel"
              required>
              <div [hidden]="name.valid || name.pristine"
                class="alert alert-danger mb-1">
                {{ 'REPORT.NAME_REQUIRED' | translate }}

              </div>
            </div>
            <div class="mx-1 mt-4">

              <div class="accordion" id="columnsAccordion">
                <div class="accordion-item">
                  <h2 class="accordion-header">

                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      data-bs-target="#collapseColumns" aria-expanded="false" (click)="collapseElements('#columnsAccordion')"
                      aria-controls="collapseColumns">
                      Report Columns (+/-)
                    </button>
                  </h2>


                  <div id="collapseColumns" class="accordion-collapse collapse"
                    data-bs-parent="#columnsAccordion">
                    <div class="accordion-body">
                      <button type="button" class="btn btn-outline-primary" (click)="addField()">
                        <lucide-icon name="plus" size="16"></lucide-icon>
                        Add new Column
                      </button>

                      @for (field of report.columns; track field; let index = $index) {
                        <div class="card mb-1 mt-2">
                          <div class="card-body">
                            <div class="d-flex justify-content-start align-middle">
                              <div class="mb-3 col-3">
                                <input placeholder="field name" [name]="'field'+index"
                                  type="text"
                                  [(ngModel)]="field.name"
                                  class="form-control form-control-lg"
                                  [maxLength]="30">
                                  <div class="form-check form-switch">
                                    <input class="form-check-input" [name]="'summable'+index" type="checkbox" role="switch" [id]="'switchCheckDefault'+index" [(ngModel)]="field.summable" [disabled]="field.groupby">
                                    <label class="form-check-label" [for]="'switchCheckDefault'+index">Summable <small>(use it only for amount fields)</small></label>
                                  </div>
                                  <div class="form-check form-switch">
                                    <input class="form-check-input" [name]="'groupby'+index" type="checkbox" role="switch" [id]="'switchCheckDefaultGroup'+index" [(ngModel)]="field.groupby" [disabled]="field.summable">
                                    <label class="form-check-label" [for]="'switchCheckDefaultGroup'+index">GroupBy</label>
                                  </div>
                                </div>
                                <div class="btn-group-sm mx-2">
                                  <button type="button" class="btn btn-outline-primary mt-2"
                                    [disabled]="field.key || !field.name.trim()"
                                    (click)="generateFieldKey(field)">
                                    <lucide-icon name="check" size="16"></lucide-icon>
                                    {{ field.key }}
                                  </button>
                                  <button type="button" class="btn btn-outline-danger mt-2"
                                    (click)="removeField(index)">
                                    <lucide-icon name="trash-2" size="16"></lucide-icon>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion mt-2" id="mappingAccordion">
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseMapping" aria-expanded="false" (click)="collapseElements('#mappingAccordion')"
                        aria-controls="collapseMapping">
                        Mapping between Dataset columns and report columns (+/-)
                      </button>
                    </h2>


                    <div id="collapseMapping" class="accordion-collapse collapse"
                      data-bs-parent="#mappingAccordion">
                      <div class="accordion-body">

                        <div class="accordion mt-2" id="mappingAccordion1">

                          @for (dataSet of report.dataSets; track dataSet; let index = $index) {
                            <div class="accordion-item">
                              <h2 class="accordion-header">
                                <button class="accordion-button collapsed" type="button"
                                  data-bs-toggle="collapse"
                                  [attr.data-bs-target]="'#collapseMapping'+index"
                                  [attr.aria-controls]="'collapseMapping'+index"
                                  aria-expanded="false">
                                  Mapping Configuration #{{ index + 1 }}
                                </button>
                              </h2>
                              <div [id]="'collapseMapping'+index"
                                class="accordion-collapse collapse"
                                data-bs-parent="#mappingAccordion1">
                                <div class="accordion-body">
                                  <div class="card mb-1 mt-2">
                                    <div class="card-body">
                                      <div class="input-group">
                                        <span class="input-group-text">Service</span>
                                        <select [(ngModel)]="dataSet.service"
                                          class="form-control"
                                          [name]="'service'+index"
                                          [title]="'select service'"
                                          #serviceLeft="ngModel" required
                                          (change)="onChangeService($event.target.value,index);">
                                          @for (value of services; track value) {
                                            <option
                                              value={{value.id}}>
                                              {{ value.name }}
                                            </option>
                                          }
                                        </select>
                                      </div>
                                      <div [hidden]="serviceLeft.valid || serviceLeft.pristine"
                                        class="alert alert-danger">
                                        {{ 'REPORT.SERVICE_REQUIRED' | translate }}
                                      </div>
                                      <div class="input-group mt-2">
                                        <span class="input-group-text">DataSet</span>
                                        <select [(ngModel)]="dataSet.fileFormat"
                                          class="form-control"
                                          [name]="'fileFormat'+index"
                                          #fileFormatLeft="ngModel" required
                                          (change)="onChangeFileFormat($event.target.value,index);">
                                          @for (value of fileFormats[index]; track value) {
                                            <option
                                              value={{value.name}}>
                                              {{ value.name }}
                                            </option>
                                          }
                                        </select>
                                      </div>
                                      <div class="mt-2">
                                        <fieldset class="app-fieldset">
                                          <legend class="app-legend">
                                            <div class="mt-1 text-secondary">Columns
                                              Mapping
                                            </div>
                                          </legend>
                                          <hr/>
                                          @for (field of readyColumns(report.columns); track field; let index_2 = $index) {
                                            <div class="d-flex justify-content-start align-middle mt-1">
                                              <div class="input-group mt-2">
                                                <span class="input-group-text"><b>{{ field.name }}
                                                  <i>({{ field.key }})</i></b> <lucide-icon name="arrow-right" size="16"></lucide-icon></span>
                                                <select [(ngModel)]="dataSet.mapping[field.key]"
                                                  class="form-control"
                                                  [name]="'column' + index + '_'+index_2"
                                                  #matchLeft="ngModel"
                                                  required>
                                                  @for (value of mappingObjects[index]; track value) {
                                                    <option
                                                      value={{value.name}}>
                                                      {{ value.name }}
                                                    </option>
                                                  }
                                                </select>
                                              </div>
                                            </div>
                                          }
                                        </fieldset>
                                      </div>
                                      <div class="mt-2">
                                        <fieldset class="app-fieldset">
                                          <legend class="app-legend">
                                            <div class="mt-1 text-secondary">
                                              Filters
                                            </div>
                                          </legend>
                                          <hr/>
                                          <button type="button"
                                            class="btn btn-outline-primary"
                                            (click)="addFilter(dataSet)">
                                            <lucide-icon name="plus" size="16"></lucide-icon>
                                            Add new Filter
                                          </button>
                                          <div class="card mt-2">
                                            <div class="card-body">
                                              @for (filter of dataSet.filters; track filter; let index_2 = $index) {
                                                <div class="row mt-2">
                                                  <div class="col-11">
                                                    <app-composite-filter [name]="'filter' + index + '_' + index_2"
                                                      [fields]="mappingObjects[index]"
                                                    [(ngModel)]="dataSet.filters[index_2]"></app-composite-filter>
                                                    <hr/>
                                                  </div>
                                                  <div class="col-1">
                                                    <button type="button"
                                                      class="btn btn-outline-danger"
                                                      (click)="removeFilter(dataSet, index_2)">
                                                      <lucide-icon name="trash-2" size="16"></lucide-icon>
                                                    </button>
                                                  </div>
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        </fieldset>
                                      </div>
                                    </div>
                                    <div class="card-footer">
                                      <div class="btn-group-sm mx-2">
                                        <button type="button"
                                          class="btn btn-outline-danger mt-2"
                                          (click)="removeMapping(index)">
                                          <lucide-icon name="trash-2" size="16"></lucide-icon>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                          <button type="button" class="btn btn-outline-primary mt-2" (click)="addMapping()">
                            <lucide-icon name="plus" size="16"></lucide-icon>
                            Add new Mapping
                          </button>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>


        @if (columns) {
          <div class="d-flex flex-column mt-5 justify-content- shadowBox ">
            <div class="mt-3">
              <button class="btn btn-sm btn-outline-success" (click)="export$()" [disabled]="exporting">
                @if (exporting) {
                  <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                }
                @if (!exporting) {
                  <lucide-icon name="file-spreadsheet" size="16"></lucide-icon>
                  }<span class="d-none d-md-inline">&nbsp;{{ 'CSV.EXCEL_DOWNLOAD' | translate }}</span><span class="d-md-none">&nbsp;XLS</span>
                </button>
              </div>
              <div class="mt-2">
                <ntr-datatable [data]="data" [metaInfo]="metaInfo" [entityTitle]="''"
                  [disableHeader]="false"
                  (onQuery)="onGridQuery($event)"
                  [columns]="columns"
                  [actionButtons]="false"
                  [headers]="['','Name','Code']">
                </ntr-datatable>
              </div>
            </div>
          }
          <br/>
          <br/>
          <br/><br/>
        </div>
      </div>
